(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canela-v2-fit-anatomy"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cv2fa]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cv2fa-tab]');
      if (!btn) return;
      var i = btn.getAttribute('data-cv2fa-tab');
      root.querySelectorAll('[data-cv2fa-tab]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', String(on));
      });
      root.querySelectorAll('[data-cv2fa-panel]').forEach(function (p) {
        var on = p.getAttribute('data-cv2fa-panel') === i;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-hidden', String(!on));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canela-v2-gap"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cv2-gap]').forEach(function (section) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setNumber(el, value) {
      el.textContent = (el.dataset.prefix || '') + value + (el.dataset.suffix || '');
    }

    function countUp(el) {
      var target = parseFloat(el.dataset.countTo);
      if (isNaN(target)) return;
      var start = null;
      var duration = 1200;
      function frame(now) {
        if (start === null) start = now;
        var p = Math.min((now - start) / duration, 1);
        setNumber(el, Math.round(target * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function reveal() {
      section.classList.add('is-in');
      section.querySelectorAll('[data-count-to]').forEach(function (el) {
        if (reduce) return setNumber(el, el.dataset.countTo);
        countUp(el);
      });
    }

    if (!('IntersectionObserver' in window)) return reveal();

    var seen = false;
    var io = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting || seen) return;
        seen = true;
        reveal();
        io.disconnect();
      },
      { threshold: 0.3 }
    );
    io.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canela-v2-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cv2-hero').forEach(function (hero) {
    var slides = hero.querySelectorAll('.cv2-hero__slide');
    if (slides.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function hydrate() {
      hero.querySelectorAll('template[data-hero-slide]').forEach(function (tpl) {
        var parent = tpl.parentNode;
        if (parent) parent.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
      });
    }

    if (document.readyState === 'complete') {
      hydrate();
    } else {
      window.addEventListener('load', hydrate, { once: true });
    }

    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5000;
    var current = 0;
    var timer = null;

    function advance() {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }

    function start() {
      if (!timer) timer = setInterval(advance, interval);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          start();
        } else {
          stop();
        }
      }, { threshold: 0.15 });
      observer.observe(hero);
    } else {
      start();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canela-v2-id-lookbook"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cv2lb]').forEach(function (root) {
    var raw = root.querySelector('[data-cv2lb-data]');
    if (!raw) return;
    var D = JSON.parse(raw.textContent);

    var tonal = root.dataset.tonal === 'true';
    var boot = root.dataset.boot;
    var strap = root.dataset.strap;

    var strip = root.querySelector('[data-lb-strip]');
    var heroImg = root.querySelector('[data-lb-hero]');
    var nameOn = root.querySelector('[data-lb-nameon]');
    var nameVal = root.querySelector('[data-lb-nameval]');

    function label(slug) { return D.names[slug].label; }
    function src(b, s, w) { return D.img[b + '|' + s] + '&width=' + w; }
    function allowed(b, s) { return tonal || b !== s; }

    // Caption is just the strap: the boot is already fixed by the chip above,
    // so repeating the full pairing wrapped to three lines on a narrow tile.
    function tileHtml(s) {
      var on = s === strap ? 'true' : 'false';
      // In compact mode there is no hero to drive, so tiles are links.
      var tag = heroImg ? 'button' : 'a';
      var attr = heroImg
        ? 'type="button" aria-pressed="' + on + '"'
        : 'href="' + D.productUrl + '?boot=' + boot + '&strap=' + s + '"';
      return '<' + tag + ' class="cv2lb__tile" data-lb-strap="' + s + '" ' + attr + '>'
        + '<span class="cv2lb__frame"><img src="' + src(boot, s, 320) + '"'
        + ' loading="lazy" width="320" height="320"'
        + ' alt="' + label(boot) + ' boot with ' + label(s) + ' strap"></span>'
        + '<span class="cv2lb__cap"><span class="cv2lb__dot" style="background:'
        + D.names[s].hex + '"></span><span>' + label(s) + '</span></span>'
        + '</' + tag + '>';
    }

    // One rail holding every tile. On mobile it is a single swipe row; on
    // desktop it is display:contents, so the tiles drop straight into the grid
    // and the column setting still governs the layout.
    function renderStrip() {
      if (!strip) return;
      var list = D.order.filter(function (s) { return allowed(boot, s); });
      strip.innerHTML = '<div class="cv2lb__rail">'
        + list.map(tileHtml).join('') + '</div>';
    }

    // The swatch rows are rendered by Liquid. A change only moves the pressed
    // state, hides the one strap that would match the boot, and renames the
    // labels — the buttons themselves are never rebuilt, so focus survives.
    function updateThumbs() {
      root.querySelectorAll('[data-lb-thumbs="boot"] [data-lb-boot]').forEach(function (t) {
        t.setAttribute('aria-pressed', String(t.dataset.lbBoot === boot));
      });
      root.querySelectorAll('[data-lb-thumbs="strap"] [data-lb-strap]').forEach(function (t) {
        var s = t.dataset.lbStrap;
        t.hidden = !allowed(boot, s);
        t.setAttribute('aria-pressed', String(s === strap));
      });
      var ab = root.querySelector('[data-lb-axisboot]');
      if (ab) ab.textContent = label(boot);
      var as = root.querySelector('[data-lb-axisstrap]');
      if (as) as.textContent = label(strap);
    }

    function renderHero() {
      if (!heroImg) return;
      heroImg.src = src(boot, strap, 800);
      heroImg.srcset = src(boot, strap, 400) + ' 400w, ' + src(boot, strap, 800) + ' 800w, ' + src(boot, strap, 1100) + ' 1100w';
      heroImg.alt = label(boot) + ' boot with ' + label(strap) + ' strap';

      var pair = root.querySelector('[data-lb-pair]');
      if (pair) pair.textContent = label(boot) + ' / ' + label(strap);
      var sub = root.querySelector('[data-lb-sub]');
      if (sub) {
        sub.textContent = (boot === strap ? 'Matching strap' : 'Two-tone') + ' · set of 4 boots';
      }
      var details = root.querySelector('[data-lb-details]');
      if (details) details.href = D.productUrl + '?boot=' + boot + '&strap=' + strap;

      var pb = root.querySelector('[data-lb-pboot]');
      if (pb) pb.value = label(boot);
      var ps = root.querySelector('[data-lb-pstrap]');
      if (ps) ps.value = label(strap);

      updateThumbs();
      renderBuy();
    }

    // Ticking the name box swaps the Shopify variant rather than adding a fee,
    // so the price shown is the price charged. Submission is held while the box
    // is ticked and the field is empty — paying for a blank name is a refund.
    function renderBuy() {
      var idField = root.querySelector('[data-lb-id]');
      if (!idField) return;
      var on = !!(nameOn && nameOn.checked && D.variants.named);
      var val = nameVal ? nameVal.value.trim() : '';
      var blocked = on && !val;

      idField.value = on ? D.variants.named : D.variants.plain;

      var priceEl = root.querySelector('[data-lb-price]');
      if (priceEl) priceEl.textContent = on ? D.variants.namedPrice : D.variants.plainPrice;

      var wrap = root.querySelector('[data-lb-namewrap]');
      if (wrap) wrap.classList.toggle('is-open', on);
      if (nameVal) {
        nameVal.disabled = !on;
        nameVal.placeholder = on ? ((D.t && D.t.phOn) || 'Their name') : ((D.t && D.t.phOff) || 'Switch on to add their name');
      }

      var pname = root.querySelector('[data-lb-pname]');
      if (pname) {
        pname.value = val;
        pname.disabled = !on || !val;
      }

      var add = root.querySelector('[data-lb-add]');
      if (add) add.disabled = blocked;
      var express = root.querySelector('.cv2lb__express');
      if (express) express.classList.toggle('is-blocked', blocked);

      var hint = root.querySelector('[data-lb-namehint]');
      if (hint) {
        hint.textContent = blocked ? ((D.t && D.t.needName) || 'Enter a name to continue') : ((D.t && D.t.hint) || 'Max 10 characters');
        hint.classList.toggle('is-warn', blocked);
      }

      // the strap preview: chosen strap color, typed name; "Canela" until a
      // name is switched on, as on the plain strap
      var prev = root.querySelector('[data-lb-preview]');
      if (prev && D.names[strap]) prev.style.setProperty('--d', D.names[strap].hex);
      var pn = root.querySelector('[data-lb-previewname]');
      if (pn) {
        pn.textContent = on ? (val || (D.t && D.t.phOn) || 'Their name') : 'Canela';
        pn.classList.toggle('is-empty', on && !val);
      }
      var cnt = root.querySelector('[data-lb-count]');
      if (cnt) cnt.textContent = val.length + '/10';
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-lb-boot]');
      if (chip) {
        boot = chip.dataset.lbBoot;
        if (!allowed(boot, strap)) {
          strap = D.order.filter(function (s) { return allowed(boot, s); })[0];
        }
        root.querySelectorAll('[data-lb-boot]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.lbBoot === boot));
        });
        var bn = root.querySelector('[data-lb-bootname]');
        if (bn) bn.textContent = ((D.t && D.t.boot) || 'Boot') + ' — ' + label(boot);
        renderStrip();
        renderHero();
        return;
      }
      var tile = e.target.closest('[data-lb-strap]');
      if (tile && heroImg) {
        e.preventDefault();
        strap = tile.dataset.lbStrap;
        root.querySelectorAll('[data-lb-strap]').forEach(function (t) {
          t.setAttribute('aria-pressed', String(t.dataset.lbStrap === strap));
        });
        renderHero();
      }
    });

    // Horizon intercepts product forms and opens <cart-drawer-component>. The
    // landing layout renders no drawer, so an unintercepted submit navigates to
    // /cart — the shopper loses the page and the sticky bundle bar with it.
    // Only take over where there is nothing to take over from.
    var lbForm = root.querySelector('.cv2lb__form');
    if (lbForm && !document.querySelector('cart-drawer-component')) {
      lbForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var add = root.querySelector('[data-lb-add]');
        var label = add ? add.textContent : '';
        if (add) { add.disabled = true; add.textContent = 'Adding…'; }
        // FormData carries the variant id and every properties[...] field, and
        // skips the disabled Name input exactly as a real submit would.
        fetch(D.cartAddUrl, {
          method: 'POST',
          body: new FormData(lbForm),
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (line) {
            if (add) {
              add.textContent = 'Added ✓';
              setTimeout(function () { add.disabled = false; add.textContent = label; }, 1400);
            }
            // The sticky bar owns cart state and cart controls. It gets the line
            // key so its Undo can remove exactly this line — every pairing shares
            // one variant, so removing by variant would take out the wrong one.
            document.dispatchEvent(new CustomEvent('cv2:cart-added', {
              detail: { key: line && line.key ? line.key : null }
            }));
          })
          .catch(function () {
            // let the browser do what it would have done anyway
            if (add) { add.disabled = false; add.textContent = label; }
            lbForm.submit();
          });
      });
    }

    if (nameOn) nameOn.addEventListener('change', renderBuy);
    if (nameVal) nameVal.addEventListener('input', renderBuy);

    // Deep links from the wall and from ads: /products/... is handled by the
    // product page, but the section also honours params on its own page.
    try {
      var q = new URLSearchParams(window.location.search);
      var qb = q.get('boot');
      var qs = q.get('strap');
      if (qb && D.names[qb]) boot = qb;
      if (qs && D.names[qs] && allowed(boot, qs)) strap = qs;
    } catch (err) { /* older browsers keep the section defaults */ }

    renderStrip();
    renderHero();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canela-v2-lifestyle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cv2-life').forEach(function (section) {
    var track = section.querySelector('.cv2-life__carousel');
    var buttons = section.querySelectorAll('.cv2-life__arrow');
    if (!track || !buttons.length) return;

    function step() {
      var slide = track.querySelector('.cv2-life__slide');
      if (!slide) return track.clientWidth;
      return slide.getBoundingClientRect().width + 14;
    }

    function sync() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      buttons.forEach(function (button) {
        if (button.dataset.dir === 'prev') {
          button.disabled = track.scrollLeft <= 0;
        } else {
          button.disabled = track.scrollLeft >= maxScroll;
        }
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var delta = button.dataset.dir === 'next' ? step() : -step();
        track.scrollBy({ left: delta, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canela-v2-product-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cv2-rail').forEach(function (section) {
    var track = section.querySelector('.cv2-rail__carousel');
    var buttons = section.querySelectorAll('.cv2-rail__arrow');
    if (!track || !buttons.length) return;

    function step() {
      var slide = track.querySelector('.cv2-rail__slide');
      if (!slide) return track.clientWidth;
      return slide.getBoundingClientRect().width + 14;
    }

    function sync() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      buttons.forEach(function (button) {
        if (button.dataset.dir === 'prev') {
          button.disabled = track.scrollLeft <= 0;
        } else {
          button.disabled = track.scrollLeft >= maxScroll;
        }
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var delta = button.dataset.dir === 'next' ? step() * 2 : step() * -2;
        track.scrollBy({ left: delta, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-cv2-rail-more]');
    if (!more) return;
    var section = more.closest('.cv2-rail');
    if (!section) return;
    section.classList.remove('is-collapsed');
    more.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canela-v2-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cv2-rev').forEach(function (section) {
    var track = section.querySelector('.cv2-rev__track');
    var buttons = section.querySelectorAll('.cv2-rev__arrow');
    if (!track || !buttons.length) return;

    function step() {
      var card = track.querySelector('.cv2-rev__card');
      return card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      buttons.forEach(function (button) {
        button.disabled =
          button.dataset.dir === 'prev' ? track.scrollLeft <= 0 : track.scrollLeft >= max;
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        track.scrollBy({
          left: button.dataset.dir === 'next' ? step() : -step(),
          behavior: 'smooth',
        });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canela-v2-social-proof"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cv2-proof').forEach(function (section) {
    var track = section.querySelector('.cv2-proof__carousel');
    var buttons = section.querySelectorAll('.cv2-proof__arrow');
    if (!track || !buttons.length) return;

    function step() {
      var slide = track.querySelector('.cv2-proof__slide');
      return slide ? slide.getBoundingClientRect().width + 14 : track.clientWidth;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      buttons.forEach(function (button) {
        button.disabled =
          button.dataset.dir === 'prev' ? track.scrollLeft <= 0 : track.scrollLeft >= max;
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        track.scrollBy({
          left: button.dataset.dir === 'next' ? step() : -step(),
          behavior: 'smooth',
        });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canela-v2-style"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cv2-sty').forEach(function (section) {
    var track = section.querySelector('.cv2-sty__track');
    var buttons = section.querySelectorAll('.cv2-sty__arrow');
    if (!track || !buttons.length) return;

    function step() {
      var item = track.querySelector('.cv2-sty__item');
      return item ? item.getBoundingClientRect().width + 14 : track.clientWidth;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      buttons.forEach(function (button) {
        button.disabled =
          button.dataset.dir === 'prev' ? track.scrollLeft <= 0 : track.scrollLeft >= max;
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        track.scrollBy({
          left: button.dataset.dir === 'next' ? step() : -step(),
          behavior: 'smooth',
        });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel_1"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.hero-carousel').forEach(function (section) {
    var id          = section.id.replace('hero-carousel-', '');
    var track       = section.querySelector('.hero-carousel__track');
    var slides      = section.querySelectorAll('.hero-carousel__slide');
    var dots        = section.querySelectorAll('.hero-carousel__dot');
    var prevBtn     = section.querySelector('#hc-prev-' + id);
    var nextBtn     = section.querySelector('#hc-next-' + id);
    var pauseBtn    = section.querySelector('#hc-pause-' + id);
    var progressEl  = section.querySelector('.hero-carousel__progress-bar');

    if (!slides.length) return;

    var current       = 0;
    var total         = slides.length;
    var autoplay      = section.dataset.autoplay === 'true' && !reducedMotion;
    var speed         = parseInt(section.dataset.speed, 10) * 1000 || 5000;
    var paused        = false;
    var timer         = null;
    var progressStart = null;

    /* ── Hand off from LCP layer to JS track ── */
    section.classList.add('hero-carousel--ready');

    /* ── Video helpers ── */
    function getVideo(slideEl) {
      return slideEl.querySelector('[data-hc-video]');
    }

    function playVideo(slideEl) {
      var v = getVideo(slideEl);
      if (v && !reducedMotion) v.play().catch(function () {});
    }

    function pauseVideo(slideEl) {
      var v = getVideo(slideEl);
      if (v) v.pause();
    }

    /* Start video on slide 1 */
    playVideo(slides[0]);

    /* ── Go to slide n ── */
    function setSlide(n) {
      pauseVideo(slides[current]);

      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = ((n % total) + total) % total;

      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }

      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      playVideo(slides[current]);
      resetProgress();
    }

    /* ── Progress bar ── */
    function resetProgress() {
      clearTimeout(timer);
      if (!progressEl) return;
      progressEl.style.transition = 'none';
      progressEl.style.width = '0%';
      if (autoplay && !paused) {
        requestAnimationFrame(function () {
          requestAnimationFrame(startProgress);
        });
      }
    }

    function startProgress() {
      if (!progressEl) return;
      progressStart = Date.now();
      progressEl.style.transition = 'width ' + speed + 'ms linear';
      progressEl.style.width = '100%';
      timer = setTimeout(function () { setSlide(current + 1); }, speed);
    }

    function freezeProgress() {
      clearTimeout(timer);
      if (!progressEl) return;
      var elapsed = Date.now() - (progressStart || Date.now());
      var pct = Math.min((elapsed / speed) * 100, 100);
      progressEl.style.transition = 'none';
      progressEl.style.width = pct + '%';
    }

    /* ── Controls ── */
    if (prevBtn) prevBtn.addEventListener('click', function () { setSlide(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setSlide(current + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        setSlide(parseInt(dot.dataset.index, 10));
      });
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        var icon = pauseBtn.querySelector('.hero-carousel__pause-icon');

        if (paused) {
          freezeProgress();
          pauseVideo(slides[current]);
          pauseBtn.setAttribute('aria-label', 'Play slideshow');
          if (icon) icon.innerHTML = '<svg width="11" height="13" viewBox="0 0 11 13" fill="white"><path d="M0 0L11 6.5L0 13V0Z"/></svg>';
        } else {
          playVideo(slides[current]);
          pauseBtn.setAttribute('aria-label', 'Pause slideshow');
          if (icon) icon.innerHTML = '<span class="hero-carousel__pause-bar"></span><span class="hero-carousel__pause-bar"></span>';
          resetProgress();
        }
      });
    }

    /* ── Keyboard ── */
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  setSlide(current - 1);
      if (e.key === 'ArrowRight') setSlide(current + 1);
    });

    /* ── Touch / swipe ── */
    var touchStartX = null;
    section.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    section.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) setSlide(diff > 0 ? current + 1 : current - 1);
      touchStartX = null;
    });

    /* ── Pause autoplay on hover ── */
    if (autoplay) {
      section.addEventListener('mouseenter', function () { if (!paused) freezeProgress(); });
      section.addEventListener('mouseleave', function () { if (!paused) resetProgress(); });
    }

    /* ── Start ── */
    if (autoplay) resetProgress();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ═══════════════════════════════
       Lightbox (works for both grid + carousel)
       ═══════════════════════════════ */
    let lightbox = null;
    let lightboxImg = null;
    let lightboxCaption = null;
    let counter = null;
    let galleryItems = [];
    let currentIndex = 0;

    window.openGalleryLightbox = function(trigger) {
      const section = trigger.closest('.image-gallery-section');
      if (!section) return;

      galleryItems = Array.from(section.querySelectorAll('[data-gallery-src]'));
      currentIndex = galleryItems.indexOf(trigger);

      lightbox = section.parentElement.querySelector('.gallery-lightbox')
                 || section.nextElementSibling;
      if (!lightbox || !lightbox.classList.contains('gallery-lightbox')) {
        const allLightboxes = document.querySelectorAll('.gallery-lightbox');
        lightbox = allLightboxes[allLightboxes.length - 1];
      }
      if (!lightbox) return;

      lightboxImg = lightbox.querySelector('.gallery-lightbox__img');
      lightboxCaption = lightbox.querySelector('.gallery-lightbox__caption');
      counter = lightbox.querySelector('.gallery-lightbox__counter');

      showImage(currentIndex);
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    window.closeGalleryLightbox = function() {
      if (!lightbox) return;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    window.navigateGallery = function(direction) {
      if (!galleryItems.length) return;
      currentIndex = (currentIndex + direction + galleryItems.length) % galleryItems.length;
      showImage(currentIndex);
    };

    function showImage(index) {
      if (!lightboxImg || !galleryItems[index]) return;
      const item = galleryItems[index];
      lightboxImg.src = item.dataset.gallerySrc;
      lightboxImg.alt = item.dataset.galleryAlt || '';
      if (counter) {
        counter.textContent = (index + 1) + ' / ' + galleryItems.length;
      }
      /* Show caption in lightbox */
      if (lightboxCaption) {
        const slide = item.closest('.image-gallery__grid-item, .image-gallery__carousel-slide');
        const headingEl = slide ? slide.querySelector('.image-gallery__caption-heading') : null;
        const captionEl = slide ? slide.querySelector('.image-gallery__caption-text') : null;
        var captionHTML = '';
        if (headingEl) captionHTML += '<strong>' + headingEl.textContent + '</strong>';
        if (headingEl && captionEl) captionHTML += '<br>';
        if (captionEl) captionHTML += captionEl.textContent;
        lightboxCaption.innerHTML = captionHTML;
      }
    }

    document.addEventListener('keydown', function(e) {
      if (!lightbox || lightbox.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') closeGalleryLightbox();
      if (e.key === 'ArrowLeft') navigateGallery(-1);
      if (e.key === 'ArrowRight') navigateGallery(1);
    });

    /* ═══════════════════════════════
       Carousel engine
       ═══════════════════════════════ */
    const carouselState = {};

    function getPerView(sectionEl) {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const style = getComputedStyle(sectionEl);
      return parseInt(
        isMobile
          ? style.getPropertyValue('--carousel-per-view-mobile')
          : style.getPropertyValue('--carousel-per-view'),
        10
      ) || 1;
    }

    function updateCarousel(sectionId) {
      const state = carouselState[sectionId];
      if (!state) return;

      const sectionEl = document.querySelector('[data-section-id="' + sectionId + '"]');
      if (!sectionEl) return;

      const perView = getPerView(sectionEl);
      const maxIndex = Math.max(0, state.totalSlides - perView);

      if (state.currentSlide > maxIndex) state.currentSlide = maxIndex;
      if (state.currentSlide < 0) state.currentSlide = 0;

      const gap = parseFloat(getComputedStyle(sectionEl).getPropertyValue('--gallery-gap')) || 12;
      const slideWidth = (state.track.parentElement.offsetWidth - gap * (perView - 1)) / perView;
      const offset = state.currentSlide * (slideWidth + gap);
      state.track.style.transform = 'translateX(-' + offset + 'px)';

      /* Update dots */
      const dotsContainer = document.getElementById('dots-' + sectionId);
      if (dotsContainer) {
        var dots = dotsContainer.querySelectorAll('.image-gallery__carousel-dot');
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === state.currentSlide);
        });
      }
    }

    window.carouselNav = function(sectionId, direction) {
      const state = carouselState[sectionId];
      if (!state) return;

      const sectionEl = document.querySelector('[data-section-id="' + sectionId + '"]');
      const perView = getPerView(sectionEl);
      const maxIndex = Math.max(0, state.totalSlides - perView);

      state.currentSlide = state.currentSlide + direction;
      if (state.currentSlide > maxIndex) state.currentSlide = 0;
      if (state.currentSlide < 0) state.currentSlide = maxIndex;

      updateCarousel(sectionId);
      resetAutoplay(sectionId);
    };

    window.carouselGoTo = function(sectionId, index) {
      const state = carouselState[sectionId];
      if (!state) return;
      state.currentSlide = index;
      updateCarousel(sectionId);
      resetAutoplay(sectionId);
    };

    function resetAutoplay(sectionId) {
      const state = carouselState[sectionId];
      if (!state || !state.autoplayInterval) return;
      clearInterval(state.autoplayInterval);
      startAutoplay(sectionId);
    }

    function startAutoplay(sectionId) {
      const state = carouselState[sectionId];
      if (!state || !state.autoplay) return;
      state.autoplayInterval = setInterval(function() {
        carouselNav(sectionId, 1);
      }, state.autoplaySpeed);
    }

    /* Initialise all carousels on the page */
    function initCarousels() {
      document.querySelectorAll('.image-gallery-section--carousel').forEach(function(sectionEl) {
        const sectionId = sectionEl.dataset.sectionId;
        const track = sectionEl.querySelector('.image-gallery__carousel-track');
        if (!track) return;

        const slides = track.querySelectorAll('.image-gallery__carousel-slide');
        const autoplay = sectionEl.dataset.autoplay === 'true';
        const autoplaySpeed = parseInt(sectionEl.dataset.autoplaySpeed, 10) || 5000;

        carouselState[sectionId] = {
          track: track,
          totalSlides: slides.length,
          currentSlide: 0,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          autoplayInterval: null
        };

        updateCarousel(sectionId);
        if (autoplay) startAutoplay(sectionId);

        /* Pause autoplay on hover */
        sectionEl.addEventListener('mouseenter', function() {
          var state = carouselState[sectionId];
          if (state && state.autoplayInterval) {
            clearInterval(state.autoplayInterval);
            state.autoplayInterval = null;
          }
        });

        sectionEl.addEventListener('mouseleave', function() {
          var state = carouselState[sectionId];
          if (state && state.autoplay && !state.autoplayInterval) {
            startAutoplay(sectionId);
          }
        });

        /* Touch / swipe support */
        let touchStartX = 0;
        let touchDiff = 0;
        track.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        track.addEventListener('touchmove', function(e) {
          touchDiff = e.touches[0].clientX - touchStartX;
        }, { passive: true });
        track.addEventListener('touchend', function() {
          if (Math.abs(touchDiff) > 50) {
            carouselNav(sectionId, touchDiff > 0 ? -1 : 1);
          }
          touchDiff = 0;
        });
      });
    }

    /* Handle resize */
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        Object.keys(carouselState).forEach(function(id) {
          updateCarousel(id);
        });
      }, 150);
    });

    /* Init on DOM ready */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCarousels);
    } else {
      initCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
